'use client';

import { PaginationV2 } from '@pickleballinc/react-ui';
import { useRouter, useSearchParams } from 'next/navigation';

interface PaginationProps {
	totalRecords: number;
	pageSize: number;
}

export const Pagination = ({ totalRecords, pageSize }: PaginationProps) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const page = searchParams?.get('page') ? Number(searchParams?.get('page')) : 1;
	const handlePageChange = (newPage: number) => {
		const newSearchParams = new URLSearchParams(searchParams || '');
		newSearchParams.set('page', newPage.toString());
		router.replace(`?${newSearchParams.toString()}`);
	};
	return (
		<PaginationV2
			currentPage={page}
			totalNumberOfPages={Math.ceil(totalRecords / pageSize)}
			onPreviousClick={() => handlePageChange(page - 1)}
			onNextClick={() => handlePageChange(page + 1)}
			onPageClick={(newPage) => handlePageChange(newPage)}
		/>
	);
};
